import BaseLang from '@/locale/lang/zh-CN.js';

var SpeLang = {};
for(var v in BaseLang){
    SpeLang[v] = BaseLang[v];
}
SpeLang.speOrder = {
    mtoNo:'MTO',
    batchNo:'批号',
    X_PerPieceQty:'单件数量',
}
export default SpeLang;